module.exports = __webpack_public_path__ + "static/img/nav2.43435f07.png";